/*
 * Copyright (c) Ekathva Innovations Private Limited- All Rights Reserved
 * Unauthorized copying of this file, via any medium, is strictly prohibited
 * Proprietary and confidential
 *
 * Author: Nikitha S Bhatt (nikitha@ekathvainnovations.com), Akshay K Kulkarni (akshay.kulkarni@ekathvainnovations.com)
 *
 * Date:08-06-2021
 *
 * Filename: CareerPage
 * Page name: Career
 * Page Description: This is the career page of the website of Ekathva Innovations, it consists of all the
 * details about the career options.
 */

import React, { useEffect } from "react";
import MetaTags from "react-meta-tags";

import Navbar from "components/Navbars/Navbar";
import LandingPageCareer from "components/Headers/LandingPageCareer";
import Footer from "components/Footers/Footer";

import { Card, CardTitle } from "reactstrap";
import { Image } from "react-bootstrap";

import "assets/style/Style.css";

import NoOpenings from "assets/images/Career/NoOpenings.jpg";

function Career() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <MetaTags>
        <title>
          Careers - IT, Embedded system, IoT, Web development, Software, IT jobs
          in shivamogga| Ekathva Innovations Pvt Ltd
        </title>
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0"
        ></meta>
      </MetaTags>

      <Navbar />
      <LandingPageCareer />

      <div className="aboutus_mainspace">
        <br />
        <p>
          <strong>
            We are looking for Talented & Smart Professionals who can bring new
            innovative ideas and positive attitudes to our growing teams. We
            continuously look for like-minded professionals who have the passion
            to create something amazing. Join Us
          </strong>
        </p>
      </div>
      <div className="aboutus_mainspace  d-flex justify-content-center">
        <br />
        <Card style={{ width: 300 }}>
          <Image img src={NoOpenings} alt="NoOpenings" />
          <CardTitle className="carouselBottomMargin">
            <div className="homepageproducts_headingspace aboutus_textalign">
              <h5 className="career_textalign">
                Currently There are No Openings!!!
              </h5>
            </div>
          </CardTitle>
        </Card>
        <br />
        <br />
      </div>
      <Footer />
    </div>
  );
}

export default Career;
